var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgİcDeposit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 8m-8 0a8 8 0 1 1 16 0a8 8 0 1 1 -16 0",
    fill: "#E9F8EE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_deposit)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5 6.5H10.5V9.795L4.705 4L4 4.705L9.795 10.5H6.5V11.5H11.5V6.5Z",
    fill: "#13BF86"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_deposit"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgİcDeposit);
export default __webpack_public_path__ + "static/media/ic_deposit.1ba3dfcdbf2af0b86a1c04f8fe455a85.svg";
export { ForwardRef as ReactComponent };